import http from 'hub-http/clients/apiClient';
const BASE_URL = `data-privacy-settings/hub-settings`;
export const getDataPrivacySettings = ({
  portalId = 0
}) => http.get(BASE_URL, {
  query: {
    portalId
  }
});
export default getDataPrivacySettings;